import config from "./config";

export const SISTER_LOCALES = ["en", "es", "ru"];

export function isSisterStore(locale = config.STORE_LOCALE) {
  return SISTER_LOCALES.includes(locale);
}

export function defaultDial(locale = config.STORE_LOCALE) {
  if (locale === "ru") return "+7";
  if (locale === "es") return "+52";
  if (locale === "en") return "+1";
  return "+55";
}

export function htmlLang(locale = config.STORE_LOCALE) {
  return { pt: "pt", en: "en", es: "es", ru: "ru" }[locale] || "pt";
}

export function dateLocale(locale = config.STORE_LOCALE) {
  return { pt: "pt-BR", en: "en-US", es: "es-MX", ru: "ru-RU" }[locale] || "pt-BR";
}

export function storeTitle(locale = config.STORE_LOCALE) {
  return {
    pt: "Personal Shopper de Luxo",
    en: "Luxury Personal Shopper",
    es: "Personal Shopper de Lujo",
    ru: "Люксовый Personal Shopper",
  }[locale] || "Luxury Personal Shopper";
}
